import { IconButton } from '@sweep-io/sweep-design';
import { ChevronLeft } from '@sweep-io/sweep-design/dist/icons';

export const BackButton = ({ onClick }: { onClick: () => void }) => (
  <IconButton variant="flat" size="tiny" onClick={onClick}>
    <ChevronLeft size="medium" />
  </IconButton>
);
